import { Injectable } from '@angular/core';

export type TripUseCase = 1 | 2 | 3;

export interface TripFlowChoice {
  useCase: TripUseCase;
  retailerId?: string;
  savedAt: number;
}

const STORAGE_KEY = 'gm_trip_flow_choice';
const TTL_MS = 0; // 0 = never expire

@Injectable({ providedIn: 'root' })
export class TripFlowService {

  saveChoice(useCase: TripUseCase, retailerId?: string): void {
    const choice: TripFlowChoice = { useCase, retailerId, savedAt: Date.now() };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(choice));
    } catch {
      // localStorage unavailable (SSR / private mode)
    }
  }

  getChoice(): TripFlowChoice | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const choice: TripFlowChoice = JSON.parse(raw);
      if (Date.now() - choice.savedAt > TTL_MS) {
        this.clearChoice();
        return null;
      }
      return choice;
    } catch {
      return null;
    }
  }

  clearChoice(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch { /* noop */ }
  }

  shouldShowPopup(): boolean {
    return this.getChoice() === null;
  }
}
